/* Small pure URL helpers shared by the controller and regression tests. */
(function(root){
  const own = name => name==='q'||name==='type'||name==='sort_by'||name==='options[prefix]'||name.startsWith('filter.');
  function formURL(action,current,entries){
    const url=new URL(action,current), prior=new URL(current);
    for(const [key,value] of prior.searchParams)if(!own(key)&&!['page','section_id','sections'].includes(key))url.searchParams.append(key,value);
    for(const [key,value] of entries)if(typeof value==='string'&&value.trim()!=='')url.searchParams.append(key,value);
    url.hash='';return url;
  }
  function ordinaryClick(event){return event.button===0&&!event.metaKey&&!event.ctrlKey&&!event.altKey&&!event.shiftKey;}
  const api={formURL,ordinaryClick};if(typeof module!=='undefined')module.exports=api;else root.PawBrowsingCore=api;
})(typeof window==='undefined'?globalThis:window);
